<div class="w-full flex flex-col gap-[6px] items-center">
    <ng-otp-input #ngOtpInput (onInputChange)="onOtpChange($event)" *ngIf="showOtpComponent" [config]="config"></ng-otp-input>
    <span class="text-[10px] text-[#FF0000] font-[400] h-[16px]">{{ error }}</span>
</div>
